import { client } from '../http';

async function setCategoryAsShown(trackingCategoryId) {
  const response = await client.post('/api/tracking-categories-display', { display: 'show', trackingCategoryId });
  return response.data;
}

async function setTrackingCategoriesSelectionAsDone() {
  const response = await client.post('/api/tracking-categories-display/done', {});
  return response.data;
}

async function updateTrackingCategory({ categoryId, category }) {
  const response = await client.put(`/api/tracking-categories/${categoryId}`, category);
  return response.data;
}

async function updateTrackingCategoryConstantPrediction({ categoryId, amount }) {
  return await _updateTrackingCategoryPrediction({
    categoryId,
    prediction: {
      defaultAmount: {
        type: 'constant',
        config: {
          value: amount,
        },
      },
    },
  });
}

async function updateTrackingCategoryHeuristicPrediction(categoryId) {
  return await _updateTrackingCategoryPrediction({
    categoryId,
    prediction: {
      defaultAmount: {
        type: 'heuristic',
        config: {
          heuristic: 'default',
        },
      },
    },
  });
}

async function _updateTrackingCategoryPrediction({ categoryId, prediction }) {
  const response = await client.put(`/api/tracking-categories/prediction/${categoryId}`, prediction);
  return response.data;
}

export async function updateTrackingCategoriesDisplaySettings(order) {
  const response = await client.post('/api/tracking-categories/display-settings', { order });
  return response.data;
}

export async function getTrackingCategoriesDisplaySettings() {
  const response = await client.get('/api/tracking-categories/display-settings');
  return response.data;
}

export default {
  setCategoryAsShown,
  setTrackingCategoriesSelectionAsDone,
  updateTrackingCategory,
  updateTrackingCategoriesDisplaySettings,
  getTrackingCategoriesDisplaySettings,
  updateTrackingCategoryConstantPrediction,
  updateTrackingCategoryHeuristicPrediction,
};
